import type { AxiosError, InternalAxiosRequestConfig } from 'axios';
import axios from 'axios';

let authToken: string | null = null;
let onUnauthorized: (() => void) | null = null;

export function setAuthToken(token: string): void {
  authToken = token;
}

export function clearAuthToken(): void {
  authToken = null;
}

export function getAuthToken(): string | null {
  return authToken;
}

export function setOnUnauthorized(callback: () => void): void {
  onUnauthorized = callback;
}

export const httpClient = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

httpClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (config.headers?.Authorization) {
    return config;
  }

  if (authToken && config.headers) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }

  return config;
});

// Unwrap backend envelopes only when they actually carry a `data` payload.
httpClient.interceptors.response.use(
  (response) => {
    const body = response.data;

    if (body && typeof body === 'object' && 'ok' in body) {
      if (!body.ok) {
        const err = new Error(body.error || 'request failed');

        return Promise.reject(err);
      }

      if ('data' in body) {
        response.data = body.data;
      }
    }

    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      clearAuthToken();
      onUnauthorized?.();
    }

    return Promise.reject(error);
  },
);
